import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { InputController } from '@/components/form/controllers/input-controller';
import { cn } from '@/lib/utils';

import type { EstatesFiltersSchemaType } from '../schemas';
import {
  activeFilterFieldClassName,
  activeFilterInputClassName,
  hasActiveFilterValue,
} from './estate-filter-active-field';

interface Props {
  classNames?: {
    container?: string;
  };
}

export const EstateFilterLivingAreaRooms = ({ classNames }: Props) => {
  const { t } = useTranslation();

  const methods = useFormContext<EstatesFiltersSchemaType>();
  const roomsMin = methods.watch('rooms.min');
  const roomsMax = methods.watch('rooms.max');

  return (
    <fieldset className={cn('mb-6 space-y-3', classNames?.container)}>
      <div className="border-t border-[hsl(214.3_31.8%_91.4%)]" />
      <p className="mb-3 text-sm font-semibold text-[#2F3A4A]">
        {t('numberOfRooms', 'Number of Rooms')}
      </p>
      <div className="grid grid-cols-2 gap-4">
        <div className={cn(hasActiveFilterValue(roomsMin) && activeFilterFieldClassName)}>
          <p className="mb-1 text-xs font-medium text-[#68778E]">{t('min', 'Min')}</p>
          <InputController
            methods={methods}
            name="rooms.min"
            type="number"
            size="sm"
            min={0}
            className={cn(
              '!border-border text-text-secondary placeholder:text-text-secondary hover:!border-primary-light focus-visible:!border-primary-light',
              hasActiveFilterValue(roomsMin) && activeFilterInputClassName
            )}
            placeholder="0"
          />
        </div>
        <div className={cn(hasActiveFilterValue(roomsMax) && activeFilterFieldClassName)}>
          <p className="mb-1 text-xs font-medium text-[#68778E]">{t('max', 'Max')}</p>
          <InputController
            methods={methods}
            name="rooms.max"
            type="number"
            size="sm"
            min={0}
            className={cn(
              '!border-border text-text-secondary placeholder:text-text-secondary hover:!border-primary-light focus-visible:!border-primary-light',
              hasActiveFilterValue(roomsMax) && activeFilterInputClassName
            )}
            placeholder="10"
          />
        </div>
      </div>
    </fieldset>
  );
};
